import { Controller } from 'stimulus';
import AutoNumeric from 'autonumeric'

export default class extends Controller {
  static targets = [ 'amount']

  static values = {
    currencyCode: String,
  };

  connect() {
    const autoNumericOptionsUSD = {
      digitGroupSeparator        : ',',
      decimalCharacter           : '.',
      decimalCharacterAlternative: ',',
      currencySymbol             : '\u202fUS$  ',
      currencySymbolPlacement    : AutoNumeric.options.currencySymbolPlacement.prefix,
      roundingMethod             : 'B',
      decimalPlaces              : 2,
      selectNumberOnly           : true,
      unformatOnSubmit           : true,
      emptyInputBehavior         : "always",
      modifyValueOnWheel         : false
    }

    const autoNumericOptionsCAD = {
      digitGroupSeparator        : ',',
      decimalCharacter           : '.',
      decimalCharacterAlternative: ',',
      currencySymbol             : '\u202fC$  ',
      currencySymbolPlacement    : AutoNumeric.options.currencySymbolPlacement.prefix,
      roundingMethod             : 'B',
      decimalPlaces              : 2,
      selectNumberOnly           : true,
      unformatOnSubmit           : true,
      emptyInputBehavior         : "always",
      modifyValueOnWheel         : false
    }

    const autoNumericOptionsAUD = {
      digitGroupSeparator        : ',',
      decimalCharacter           : '.',
      decimalCharacterAlternative: ',',
      currencySymbol             : '\u202fA$  ',
      currencySymbolPlacement    : AutoNumeric.options.currencySymbolPlacement.prefix,
      roundingMethod             : 'B',
      decimalPlaces              : 2,
      selectNumberOnly           : true,
      unformatOnSubmit           : true,
      emptyInputBehavior         : "always",
      modifyValueOnWheel         : false
    }

    const autoNumericOptionsGBP = {
      digitGroupSeparator        : ',',
      decimalCharacter           : '.',
      decimalCharacterAlternative: ',',
      currencySymbol             : '\u202f£  ',
      currencySymbolPlacement    : AutoNumeric.options.currencySymbolPlacement.prefix,
      roundingMethod             : 'B',
      decimalPlaces              : 2,
      selectNumberOnly           : true,
      unformatOnSubmit           : true,
      emptyInputBehavior         : "always",
      modifyValueOnWheel         : false
    }

    var currencyCode = this.currencyCodeValue.toLowerCase()
    switch(currencyCode) {
      case 'usd':
        this.autoNumericOptions = autoNumericOptionsUSD
        break;
      case 'cad':
        this.autoNumericOptions = autoNumericOptionsCAD
        break;
      case 'aud':
        this.autoNumericOptions = autoNumericOptionsAUD
        break;
      case 'gbp':
        this.autoNumericOptions = autoNumericOptionsGBP
        break;
      default:
        this.autoNumericOptions = autoNumericOptionsUSD
    }

    if (!AutoNumeric.isManagedByAutoNumeric(this.amountTarget)) {
      new AutoNumeric(this.amountTarget, this.autoNumericOptions)
    }
  }
}